import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { alertLabels } from '../configuration/alert-labels/index.js';
import { useErrorMessageContext } from '../context/ErrorMessageContext/context.js';
import { GET_RETURN_FOR_LOGIN } from '../operations/queries/get-return-for-login.js';
import { getStatusBasedErrorLabel } from '../utils/get-status-based-error-label.js';

const useLogin = ({ onCompleted , onError  } = {})=>{
    const [{ addError , clearErrors  }] = useErrorMessageContext();
    const handleOnCompleted = React.useCallback((result)=>{
        var ref, ref1, ref2, ref3, ref4;
        clearErrors();
        if (((ref = result.getReturn) === null || ref === void 0 ? void 0 : ref.failures) && ((ref1 = result.getReturn) === null || ref1 === void 0 ? void 0 : ref1.failures.length) > 0) {
            var ref5;
            const labelMap = Util.mapFailuresToAlertLabels((ref5 = result.getReturn) === null || ref5 === void 0 ? void 0 : ref5.failures, alertLabels, 'returns.errors.returnGeneralFailure.title');
            labelMap.forEach((label)=>addError(label)
            );
        }
        // Handle status-based errors (when return exists but isn't returnable)
        if (((ref2 = result.getReturn) === null || ref2 === void 0 ? void 0 : ref2.return) && ((ref3 = result.getReturn) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.return) === null || ref4 === void 0 ? void 0 : ref4.status) !== 'RETURNABLE') {
            const errorLabel = getStatusBasedErrorLabel(result.getReturn.return.status);
            addError(errorLabel);
        }
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(result);
    }, [
        addError,
        clearErrors,
        onCompleted
    ]);
    const [query, { called , data , error: error1 , loading  }] = useLazyQuery(GET_RETURN_FOR_LOGIN, {
        onCompleted: handleOnCompleted,
        onError (error) {
            console.error(error);
            onError === null || onError === void 0 ? void 0 : onError();
        },
        fetchPolicy: 'no-cache'
    });
    const trigger = React.useCallback((input)=>{
        query({
            variables: {
                input
            }
        });
    }, [
        query
    ]);
    return React.useMemo(()=>[
            trigger,
            {
                called,
                data,
                error: error1,
                loading
            }, 
        ]
    , [
        trigger,
        called,
        data,
        error1,
        loading
    ]);
};

export { useLogin };
//# sourceMappingURL=use-login.js.map
